import {SystemRuleType} from '@birco/rainmesh-api';

export type RuleNameSource = {
  name: string;
  isSystemRule?: boolean;
  systemRuleType?: SystemRuleType;
};

export function getDisplayRuleName(
  rule: RuleNameSource | null | undefined,
  translate: (key: string) => string,
  cisternName?: string | null,
): string {
  if (!rule) {
    return '';
  }

  if (!rule.isSystemRule) {
    return rule.name;
  }

  let translationKey: string | null = null;

  switch (rule.systemRuleType) {
    case SystemRuleType.AUTOMATED_CISTERN_OVERFLOW_PROTECTION:
      translationKey = 'rules.systemRule.automated_cistern_overflow_protection';
      break;
    default:
      return rule.name;
  }

  const translatedName = translate(translationKey);
  return cisternName ? `${translatedName} ${cisternName}` : translatedName;
}
